import MakeTag from "../makeTag/MakeTag";
export default function ReactJSTag() {
  return (<>
    <MakeTag tagText="React JS" color="#5ed3f3" />
    <MakeTag tagText="JavaScript" color="rgb(232, 210, 22)" />
    <MakeTag tagText="HTML" color="#dd4b24" />
    <MakeTag tagText="CSS" color="#254bdd" />

  </>);
}